import { Box } from "@chakra-ui/react";

export function NoEnrolledIcon() {
  return (
    <Box>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="90"
        height="90"
        viewBox="0 0 90 90"
        fill="none"
      >
        <path
          d="M49.1666 86.6673H22.4619C16.0228 86.6673 10.9012 83.5341 6.30267 79.153C-3.11106 70.1845 12.3449 63.0173 18.2398 59.5073C28.2365 53.5548 40.177 51.907 51.2499 54.5639"
          stroke="#0073E0"
          stroke-width="6.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M63.75 22.084C63.75 32.4393 55.3553 40.834 45 40.834C34.6447 40.834 26.25 32.4393 26.25 22.084C26.25 11.7286 34.6447 3.33398 45 3.33398C55.3553 3.33398 63.75 11.7286 63.75 22.084Z"
          stroke="#0073E0"
          stroke-width="6.25"
        />
        <path
          d="M61.6665 86.666L74.1665 74.166M74.1665 74.166L86.6665 61.666M74.1665 74.166L61.6665 61.666M74.1665 74.166L86.6665 86.666"
          stroke="#0073E0"
          stroke-width="6.25"
          stroke-linecap="round"
        />
      </svg>
    </Box>
  );
}
